import { render, staticRenderFns } from "./PlayTreasureHunt.vue?vue&type=template&id=84b3a7e0&scoped=true&"
import script from "./PlayTreasureHunt.vue?vue&type=script&lang=js&"
export * from "./PlayTreasureHunt.vue?vue&type=script&lang=js&"
import style0 from "./PlayTreasureHunt.vue?vue&type=style&index=0&id=84b3a7e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b3a7e0",
  null
  
)

export default component.exports